import React from 'react';
import { Block } from "@randajan/jet-react/dom/block";
import { LinkMail } from "@randajan/jet-react/dom/link";

import "./FootPane.scss"

export const FootPane = (props)=>{
    const {} = props;
    
    return (
        <Block className="FootPane">
            <div className="copyright">{"Impostor s.r.o."}</div>
            <LinkMail>{"iva@fruhling.cz"}</LinkMail>
        </Block>
    )
}

